export default __webpack_public_path__ + "static/media/closeIco.7552214d.svg";